import type {
  ColumnFiltersState,
  PaginationState,
  RowSelectionState,
  SortingState,
  VisibilityState,
} from "@tanstack/react-table";

/**
 * Table state for conversations table
 */
export interface ConversationsTableState {
  pagination: PaginationState;
  sorting: SortingState;
  columnFilters: ColumnFiltersState;
  columnVisibility: VisibilityState;
  rowSelection: RowSelectionState;
  globalFilter: string;
}

/**
 * Default pagination values
 */
export const DEFAULT_PAGE_SIZE = 25;

export const DEFAULT_PAGINATION_STATE: PaginationState = {
  pageIndex: 0,
  pageSize: DEFAULT_PAGE_SIZE,
};

export const DEFAULT_SORTING_STATE: SortingState = [
  { id: "lastCustomerMessageAt", desc: true },
];

export const DEFAULT_COLUMN_FILTERS: ColumnFiltersState = [];

export const DEFAULT_COLUMN_VISIBILITY: VisibilityState = {};

export const DEFAULT_ROW_SELECTION: RowSelectionState = {};

/**
 * Column meta type for DataTable compatibility
 */
export interface ConversationColumnMeta {
  label: string;
  variant?: "text" | "date" | "badge" | "status";
}
